<template>
    <section class="entries">
        <FeedSkeleton class="feedSkeleton"
            v-if="loading"/>
        <EntryFeed
            v-else
            :entries="userArtworks"/>
        <FeedSkeleton class="resetMargin"
            v-if="!userEntriesReachedBottom && userArtworks.length !== 0"
            v-view="handleView"/>
    </section>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import EntryFeed    from '@/components/journal/main/EntryFeed'
    import FeedSkeleton from '@/components/layout/main/FeedSkeleton'

    export default {
        name: 'Creator',
        components: {
            EntryFeed,
            FeedSkeleton
        },
        props: {
            id: String,
            slug: String
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState('users',  ['lastVisitedSlug']),
            ...mapState('journal',['userArtworks','userEntriesReachedBottom']),

            lastVisible() {
                return this.userArtworks[this.userArtworks.length - 1]
            }
        },
        methods: {
            ...mapActions('users',  ['setLastVisitedSlug']),
            ...mapActions('journal',['fetchEntries','fetchEntriesAfter','purgeUserEntries']),

            async loadFeed() {
                try {
                    await this.fetchEntries({
                        commitName:         'setUserArtworks',
                        feedType:           'userEntries',
                        timelinePreference:  this.preferences.timeline,
                        orderPreference:     this.preferences.order,
                        artistID:            this.id,
                        visibility:          true,
                        limit:               2
                    })
                    this.loading = false
                } catch(e) {
                    throw e
                }
            },
            async handleView(event) {
                if(event.type === 'enter' && !this.loading) {
                    await this.fetchEntriesAfter({
                        commitName:         'addUserArtworks',
                        feedType:           'userEntries',
                        timelinePreference:  this.preferences.timeline,
                        orderPreference:     this.preferences.order,
                        lastVisible:         this.lastVisible,
                        artistID:            this.id,
                        visibility:          true,
                        limit:               2
                    })
                }
            }
        },
        async mounted() {
            if(this.userArtworks.length === 0) {
                this.loadFeed()
            } else if(this.slug !== this.lastVisitedSlug) {
                this.purgeUserEntries()
                this.loadFeed()
                setTimeout(() => {
                    window.scrollTo(0, 0)
                })
            } else {
                this.loading = false
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .entries {
        flex: 1;
    }
</style>
